module.exports = __webpack_public_path__ + "static/img/8f65f16071697dd741e87cdd9784d222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bground.png
// module id = /4iA
// module chunks = 1